module.exports = __webpack_public_path__ + "static/media/cactus.69a61ffa.png";